import React from 'react';
import { ListChecks, Circle, Play, CheckCircle2, AlertTriangle, UserX } from 'lucide-react';

export const computeCounters = (tasks) => ({
  total: tasks.length,
  a_faire: tasks.filter(t => t.status === 'a_faire').length,
  en_cours: tasks.filter(t => t.status === 'en_cours').length,
  terminee: tasks.filter(t => ['terminee', 'validee', 'a_valider'].includes(t.status)).length,
  late: tasks.filter(t => t.is_late).length,
  unassigned: tasks.filter(t => !(t.assigned_user_ids || []).length && !['validee', 'terminee', 'non_realisee', 'annulee'].includes(t.status)).length,
});

const ITEMS = [
  { key: 'total', label: 'Total', icon: ListChecks, cls: 'border-gray-200 text-gray-800', filter: null },
  { key: 'a_faire', label: 'À faire', icon: Circle, cls: 'border-blue-200 text-blue-700', filter: { status: 'a_faire' } },
  { key: 'en_cours', label: 'En cours', icon: Play, cls: 'border-orange-300 text-orange-700', filter: { status: 'en_cours' } },
  { key: 'terminee', label: 'Terminées', icon: CheckCircle2, cls: 'border-emerald-300 text-emerald-700', filter: { done: true } },
  { key: 'late', label: 'En retard', icon: AlertTriangle, cls: 'border-red-300 text-red-700', filter: { late: true } },
  { key: 'unassigned', label: 'Non affectées', icon: UserX, cls: 'border-gray-300 text-gray-700', filter: { unassigned: true } },
];

const TaskCounters = ({ counters, onQuickFilter, active }) => (
  <div className="grid grid-cols-3 md:grid-cols-6 gap-2" data-testid="task-counters">
    {ITEMS.map(it => {
      const isActive = active === it.key;
      return (
        <button key={it.key} type="button" onClick={() => onQuickFilter?.(it.key, it.filter)}
          className={`bg-white border-2 rounded-2xl p-2.5 md:p-3 text-left min-h-[64px] transition-colors ${it.cls} ${isActive ? 'ring-2 ring-neon-pink' : 'hover:bg-gray-50'}`}
          data-testid={`counter-${it.key}`}>
          <div className="flex items-center gap-1 text-[10px] md:text-xs font-bold uppercase tracking-wide"><it.icon size={12} />{it.label}</div>
          <div className="font-heading text-2xl font-bold" data-testid={`counter-${it.key}-value`}>{counters[it.key]}</div>
        </button>
      );
    })}
  </div>
);

export default TaskCounters;
